import LIGHT_COLORS from 'theme/colors/light-colors';

const styles = {
  inputContainerStyle: {
    backgroundColor: LIGHT_COLORS.neutral0,
  },
};

export default styles;
